export const getAllCheckedKeys = (data) => {
  let checkedKeys = [];

  data.forEach((item) => {
    if (item.module.checked) {
      checkedKeys.push(item.module.key);
    }
    // Check the firstCategory checked status
    if (item.firstCategory.checked) {
      checkedKeys.push(item.firstCategory.key);
    }

    // Iterate through secondCategory items
    item.secondCategory.forEach((scItem) => {
      // Check the secondCategory checked status
      if (scItem.treeData) {
        checkedKeys = checkedKeys.concat(scItem.checkedKeys);
      } else if (scItem.checked) {
        checkedKeys.push(scItem.key);
      }
    });
  });
  // remove duplicate keys
  checkedKeys = Array.from(new Set(checkedKeys));
  return checkedKeys;
};

export const updateModule = (data) => {
  return data.map((moduleItem) => {
    const moduleItemCopy = { ...moduleItem };
    let firstCategoryCheckedCount = 0; // 一级分类勾选数量
    let firstCategoryTotalCount = 0; // 一级分类总数量
    let secondCategoryCheckedCount = 0; // 二级分类勾选数量（不包含树组件，即有treeData的项）
    let secondCategoryTreeCheckedCount = 0; // 二级分类树节点勾选数量
    let secondCategoryTreeNodeCount = 0; // 二级分类树节点总数量
    let secondCategoryTotalCount = 0; // 二级分类总数量（包含树节点）

    data.forEach((item) => {
      if (item.firstCategory.pid === moduleItemCopy.module.key) {
        firstCategoryTotalCount += 1;
        if (item.firstCategory.checked) {
          firstCategoryCheckedCount += 1;
        }
      }

      item.secondCategory.forEach((scItem) => {
        if (item.module.key === moduleItemCopy.module.key) {
          if (scItem.checked && !scItem.treeData) {
            secondCategoryTotalCount += 1;
            secondCategoryCheckedCount += 1;
          }
          if (scItem.checkedKeys && scItem.checkedKeys.length > 0) {
            secondCategoryTreeNodeCount += scItem.children.length;
            // Check if all children are checked
            if (
              scItem.children.every((child) =>
                scItem.checkedKeys.includes(child.group_id)
              )
            ) {
              secondCategoryTreeCheckedCount += scItem.children.length;
            } else {
              secondCategoryTreeCheckedCount += scItem.checkedKeys.length;
            }
          }
        }
      });
    });

    const totalCheckedCount =
      firstCategoryCheckedCount +
      secondCategoryCheckedCount +
      secondCategoryTreeCheckedCount;
    const totalItemCount =
      firstCategoryTotalCount +
      secondCategoryTotalCount +
      secondCategoryTreeNodeCount;

    if (totalCheckedCount === 0) {
      moduleItemCopy.module.checked = false;
      moduleItemCopy.module.indeterminate = false;
    } else if (totalCheckedCount === totalItemCount) {
      moduleItemCopy.module.checked = true;
      moduleItemCopy.module.indeterminate = false;
    } else {
      moduleItemCopy.module.checked = false;
      moduleItemCopy.module.indeterminate = true;
    }

    return moduleItemCopy;
  });
};
function allChildrenIncluded(category, checkedKeys) {
  return category.children.every((child) =>
    checkedKeys.includes(child.group_id)
  );
}
export const flattenPermissions = (permissions, checkedKeys) => {
  const data = [];
  permissions.forEach((permission) => {
    let firstCategoryRowSpan = 0;
    permission.children.forEach((firstCategory) => {
      firstCategoryRowSpan += 1;
      const secondCategoryOptions = firstCategory.children.map(
        (secondCategory) => {
          if (secondCategory.children.length > 0) {
            // If there are children, create a treeData object, render a tree
            const secondCategoryCheckedKeys = secondCategory.children
              .filter((child) => checkedKeys.includes(child.group_id))
              .map((child) => child.group_id);
            return {
              title: secondCategory.auth_name,
              key: secondCategory.group_id,
              checked: checkedKeys.includes(secondCategory.group_id),
              disabled: false,
              children: secondCategory.children,
              checkedKeys: allChildrenIncluded(secondCategory, checkedKeys)
                ? [...secondCategoryCheckedKeys, secondCategory.group_id]
                : secondCategoryCheckedKeys,
              treeData: [
                {
                  label: secondCategory.auth_name,
                  key: secondCategory.group_id,
                  checked:
                    secondCategory.children.length > 0 &&
                    secondCategory.children.every((child) =>
                      checkedKeys.includes(child.group_id)
                    ),
                  disabled: false,
                  children: secondCategory.children.map((item) => ({
                    label: item.auth_name,
                    key: item.group_id,
                    checked: checkedKeys.includes(item.group_id),
                    disabled: false,
                    children: [],
                  })),
                },
              ],
            };
          }
          // If there are no children, render a checkbox
          return {
            title: secondCategory.auth_name,
            key: secondCategory.group_id,
            checked: checkedKeys.includes(secondCategory.group_id),
            disabled: false,
            children: secondCategory.children,
          };
        }
      );

      const allChecked =
        secondCategoryOptions.length > 0 &&
        secondCategoryOptions.every((item) => {
          if (item.treeData) {
            // 如果树节点全选，那么checkedKeys会包含所有的group_id，包括 item 自己的 group_id，所以要减去 1
            const treeAllChecked = item.checkedKeys.includes(item.key);
            const effectiveCheckedKeysLength = treeAllChecked
              ? item.checkedKeys.length - 1
              : item.checkedKeys.length;
            return effectiveCheckedKeysLength === item.children.length;
          }

          return item.checked;
        });
      const someChecked = secondCategoryOptions.some((item) => {
        if (item.treeData) {
          return item.children.some((child) => {
            return item.checkedKeys.includes(child.group_id);
          });
        }
        return item.checked;
      });
      data.push({
        module: {
          title: permission.auth_name,
          // checked: checkedKeys.includes(permission.group_id),
          checked: false,
          disabled: false,
          key: permission.group_id,
          rowSpan: 0, // will be updated later
        },
        firstCategory: {
          title: firstCategory.auth_name,
          checked:
            firstCategory.children.length > 0
              ? allChecked
              : checkedKeys.includes(firstCategory.group_id),
          disabled: false,
          pid: permission.group_id,
          indeterminate: someChecked && !allChecked,
          key: firstCategory.group_id,
        },
        secondCategory: secondCategoryOptions,
      });
    });
    if (data[data.length - firstCategoryRowSpan]) {
      data[data.length - firstCategoryRowSpan].module.rowSpan =
        firstCategoryRowSpan;
    }
  });

  return updateModule(data);
};



// WEBPACK FOOTER //
// ./src/pages/positionPermissions/selectorUtils.js